var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgWarning = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.01,
  d: "M0 0h24v24H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.767 3.983c.242.1.463.248.65.434l6.167 6.167a2 2 0 0 1 0 2.833l-6.168 6.167a2.003 2.003 0 0 1-2.832 0l-6.168-6.167a2.001 2.001 0 0 1 0-2.833l6.168-6.167a2.002 2.002 0 0 1 2.183-.434Zm-1.474 9.724A1 1 0 0 0 13 13V8a1 1 0 0 0-2 0v5a1 1 0 0 0 .293.707Zm0 3a1 1 0 1 0 1.414-1.414 1 1 0 0 0-1.414 1.414Z",
  fill: "#D46B08"
})));
export default SvgWarning;